export const PendingTasks = {
    request_type: null,
    product: null,
    phase: null,
};